import { BaseFileView } from './BaseFileView';
import type { MediaIteratorData } from '@/types/node';
import type { FileKind, NodeId, Web, Edit } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class MediaIteratorView extends BaseFileView<MediaIteratorData> {
  constructor(graph: FlowGraph, nodeId: NodeId) {
    super(graph, nodeId);
  }

  getNodeData(): MediaIteratorData {
    return this.graph.store.getNodeData<MediaIteratorData>(this.nodeId);
  }

  getFilesList(): FileKind[] {
    const evaluatedParameter = this.graph.wasm.call((wasm) => wasm.evaluateParameter(this.nodeId, 'files'));
    return evaluatedParameter?.type === 'file_array' ? evaluatedParameter.value : [];
  }

  protected wasmSetFiles(wasm: Web, files: FileKind[]): Edit {
    return wasm.setParameterValue(this.nodeId, 'files', { type: 'file_array', value: files });
  }
}
